export const lateFeeMixin = {
  methods: {
    getExamFee(gradeLevel, isRetry) {
      const examFee = this.examFees.find((e) => e.gradeLevel === gradeLevel);
      if (examFee) {
        let amount = isRetry ? examFee.retryFee : examFee.regularFee;
        if (
          this.schoolYearSelected.lateFeeDate &&
          Number(new Date()) > Number(new Date(this.schoolYearSelected.lateFeeDate))
        ) {
          amount = amount + examFee.lateFee;
        }
        return amount;
      }
      return 0;
    },
  },
};
